import { render, staticRenderFns } from "./ResearchOutputAttributeExtension.vue?vue&type=template&id=00b6e8bd&scoped=true&"
import script from "./ResearchOutputAttributeExtension.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputAttributeExtension.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputAttributeExtension.vue?vue&type=style&index=0&id=00b6e8bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6e8bd",
  null
  
)

export default component.exports